import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "fill-height d-flex flex-column selection-page-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "info-container",
  "data-testid": "station-table-info-text"
}
const _hoisted_3 = { class: "ml-4" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "mt-4 flex-grow-1 position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_filter_drawer = _resolveComponent("filter-drawer")!
  const _component_station_table = _resolveComponent("station-table")!
  const _component_station_map = _resolveComponent("station-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        (_ctx.showHint)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, { color: "primary" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" mdi-alert-circle-outline ", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('station_table.info_text')), 1),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                size: "32",
                variant: "text",
                "data-testid": "remove-station-table-info-text",
                onClick: _ctx.removeHint
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: "scrim" }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" mdi-close-circle ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_btn, {
        class: _normalizeClass(_ctx.filterButtonClass),
        depressed: "",
        variant: "outlined",
        "data-testid": "filter-drawer-toggle-show",
        color: _ctx.showFilter ? 'primary' : '',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFilter = !_ctx.showFilter))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "mr-4" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" mdi-filter ", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.t('station_table.filter')), 1)
        ]),
        _: 1
      }, 8, ["class", "color"]),
      _createVNode(_component_v_tooltip, {
        text: _ctx.t('station_table.chips.matching_stations_tooltip'),
        "data-testid": "tooltip-matching-stations",
        bottom: "",
        "open-delay": 200,
        "max-width": "400",
        style: {"z-index":"99"}
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_chip, _mergeProps(props, {
            class: "ml-4",
            "data-testid": "filter-chip-station-count",
            "v-if": _ctx.stationStore.filtersAreSet
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                "data-testid": "tooltip-matching-stations-icon",
                left: ""
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" mdi-filter ", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.stationStore.getMatchingStationCount +
                '/' +
                _ctx.stationStore.getAllStationCount), 1)
            ]),
            _: 1
          }, 16, ["v-if"])
        ]),
        _: 1
      }, 8, ["text"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.stationStore.filters), (filterName) => {
        return (_openBlock(), _createBlock(_component_v_chip, {
          key: filterName,
          class: "ml-4",
          "data-testid": `filter-chip-item-${filterName}`,
          closable: "",
          "onClick:close": ($event: any) => (_ctx.removeFilter(filterName))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { left: "" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" mdi-filter ", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.t(`station_table.chips.${filterName}`)), 1)
          ]),
          _: 2
        }, 1032, ["data-testid", "onClick:close"]))
      }), 128)),
      _createVNode(_component_v_spacer, { "data-testid": "station-selection-page-spacer" }),
      _createVNode(_component_v_btn, {
        class: "zamg-button zamg-button-outline-divider text-uppercase",
        depressed: "",
        variant: "outlined",
        "data-testid": "station-table-map-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mapButtonPressed()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "mr-4" }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode(" mdi-map ", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.t('station_table.map')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_filter_drawer, {
        show: _ctx.showFilter,
        "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showFilter) = $event)),
        "data-testid": "filter-drawer",
        class: "filter-drawer",
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFilter = false))
      }, null, 8, ["show"]),
      _createVNode(_component_station_table, {
        class: "station-table",
        selected: _ctx.stationStore.selectedStations,
        items: _ctx.stationStore.getAvailableStations,
        "is-loading": _ctx.stationStore.isLoading,
        "active-filters": _ctx.stationStore.filters,
        onSelect: _ctx.handleStationSelect
      }, null, 8, ["selected", "items", "is-loading", "active-filters", "onSelect"]),
      _createVNode(_Transition, { name: "slide-from-right" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_station_map, {
            class: "station-map",
            "data-testid": "station-map",
            visible: _ctx.showMap,
            onHide: _ctx.mapButtonPressed
          }, null, 8, ["visible", "onHide"]), [
            [_vShow, _ctx.readyToRenderMap && _ctx.showMap]
          ])
        ]),
        _: 1
      })
    ])
  ]))
}